module.exports = __webpack_public_path__ + "img/logo-white.650a361f.png";